export const selectUserRole = (state) => {
    const { user } = state.user

    if (!user) return 0
    else return user.role_id

}


// WEBPACK FOOTER //
// ./src/store/user/selector.js